<template>
  <div class="text-center">
    <h3>นโยบายข้อมูลส่วนบุคคล</h3>
    <div class="mt-6">
      <v-card outlined>
        <v-card-text
          class="text-left"
          style="max-height: 430px; overflow-y: auto"
        >
        <div>

          <p style="text-indent: 36px;">
            บริษัท เจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน) และบริษัท เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน) ต่อไปเรียกว่า “กลุ่มบริษัทเจนเนอราลี่” ขอแนะนำให้ท่านทำความเข้าใจนโยบายข้อมูลส่วนบุคคล (Privacy Policy) นี้ เนื่องจากนโยบายเหล่านี้อธิบายถึงวิธีการที่บริษัทปฏิบัติต่อข้อมูลส่วนบุคคลและข้อมูลอ่อนไหวของท่าน เช่น การเก็บรวบรวม การใช้ การเปิดเผย (รวมเรียกว่า “การประมวลผลข้อมูล”) รวมถึงสิทธิต่าง ๆ ของท่านตาม พรบ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 มีผลใช้บังคับในวันที่ 1 มิถุนายน 2565 บริษัทจึงประกาศนโยบายข้อมูลส่วนบุคคล ดังต่อไปนี้</p>
            <p>
            <ul>
              <li><a href="https://generali.co.th/download/%e0%b8%99%e0%b9%82%e0%b8%a2%e0%b8%9a%e0%b8%b2%e0%b8%a2%e0%b8%82%e0%b9%89%e0%b8%ad%e0%b8%a1%e0%b8%b9%e0%b8%a5%e0%b8%aa%e0%b9%88%e0%b8%a7%e0%b8%99%e0%b8%9a%e0%b8%b8%e0%b8%84%e0%b8%84%e0%b8%a5%e0%b8%aa-2/?wpdmdl=32161&masterkey=QXktHXpQypViOJkDiYDkI7b1vbEQZ9vueuzTo3BngbJ0ALBtOV01bRHPS8N4j34OJJdZGZXMnX3sz5KSu2NtJfVmxffZqGo8HMP_yEBXGrE" target="blank">นโยบายข้อมูลส่วนบุคคลสำหรับลูกค้า</a></li>
              <li><a href="https://generali.co.th/download/privacy-policy-for-agent/?wpdmdl=32166&masterkey=SXAMf27g28-AUZz4_dXSsPNqkLwRO-a2p0d6xD8OVP0leq9Hp11UGLabtza-Z0NhXmSFW0l4aGkkq5Wx2-f57U31Zxy-fRwcCqbpNNSR8ZY" target="blank">นโยบายข้อมูลส่วนบุคคลสำหรับผู้สมัครตัวแทนและตัวแทนประกันชีวิต</a></li>
              <li><a href="https://generali.co.th/download/privacy-policy-for-general-person/?wpdmdl=32167&masterkey=Z3eYfA30jznTlh3oYtNVsHMw6_L72sbmBodVCunbAiUkPPl2WAKYRfNaJr3Q4lgXK0ztjaebwaFCfRNu4tqK3s9snokff5aM7HtXGq8ccgU" target="blank">นโยบายข้อมูลส่วนบุคคลสำหรับบุคคลทั่วไป</a></li>
              <li><a href="https://generali.co.th/download/privacy-policy-for-candidate-and-employee/?wpdmdl=32170&masterkey=04i6K4-NmjXUbKqgvKO7JgZ-U1NZiohV6N-nVk-nVYg6yEUbwm9C9eSVF4u2ZM_vQgkxxf2mh6sTUwFPHhlB41nJkGj4xQLnTkGJ9uGhsuQ" target="blank">นโยบายข้อมูลส่วนบุคคลสำหรับผู้สมัครและพนักงาน</a></li>
            </ul>
            </p>
            <p>
           สำหรับข้อมูลส่วนบุคคลและข้อมูลอ่อนไหวของท่านที่กลุ่มบริษัทเจนเนอราลี่ได้รับไว้ก่อน หรือมีอยู่ก่อน วันที่ 1 มิถุนายน 2565 ทางกลุ่มบริษัทเจนเนอราลี่จะทำการประมวลผลข้อมูลดังกล่าวตามวัตถุประสงค์เดิมต่อไป ซึ่งหากท่านไม่ประสงค์ให้กลุ่มบริษัทเจนเนอราลี่ดำเนินการดังกล่าวตามวัตถุประสงค์เดิม ท่านสามารถใช้สิทธิของท่านตามรายละเอียดที่ระบุไว้ในนโยบายข้อมูลส่วนบุคคลข้างต้น
          </p>
          </div>
           <div>
             <h3 class="text-center">PRIVACY POLICY</h3>
          <p style="text-indent: 36px;" class="mt-3">
           Generali Life Assurance (Thailand) Public Company Limited and Generali Insurance (Thailand) Public Company Limited (“Generali”, “we” or “us”) would like you to examine the Privacy Policy relevant to you, in order to get aware in detail of how we handle your personal data and sensitive data, such as collection, use, disclosure (called “Data Processing”), including your rights under the Personal Data Protection Act B.E. 2562, effective on 1 June 2022 Please find each of Privacy Policy as follows:</p>
            <p>
            <ul>
              <li><a href="https://generali.co.th/download/privacy-policy-for-customer-230301-en/?wpdmdl=59044&masterkey=QXktHXpQypViOJkDiYDkI7b1vbEQZ9vueuzTo3BngbJ0ALBtOV01bRHPS8N4j34OJJdZGZXMnX3sz5KSu2NtJfVmxffZqGo8HMP_yEBXGrE" target="blank">Privacy Policy for customer</a></li>
              <li><a href="https://generali.co.th/download/privacy-policy-for-agent/?wpdmdl=32166&masterkey=SXAMf27g28-AUZz4_dXSsPNqkLwRO-a2p0d6xD8OVP0leq9Hp11UGLabtza-Z0NhXmSFW0l4aGkkq5Wx2-f57U31Zxy-fRwcCqbpNNSR8ZY" target="blank">Privacy Policy for agent</a></li>
              <li><a href="https://generali.co.th/download/privacy-policy-for-general-person/?wpdmdl=32167&masterkey=Z3eYfA30jznTlh3oYtNVsHMw6_L72sbmBodVCunbAiUkPPl2WAKYRfNaJr3Q4lgXK0ztjaebwaFCfRNu4tqK3s9snokff5aM7HtXGq8ccgU" target="blank">Privacy Policy for general person</a></li>
              <li><a href="https://generali.co.th/download/privacy-policy-for-candidate-and-employee/?wpdmdl=32170&masterkey=04i6K4-NmjXUbKqgvKO7JgZ-U1NZiohV6N-nVk-nVYg6yEUbwm9C9eSVF4u2ZM_vQgkxxf2mh6sTUwFPHhlB41nJkGj4xQLnTkGJ9uGhsuQ" target="blank">Privacy Policy for Candidate and Employee</a></li>
            </ul>
            </p>
            <p>
For your personal data and sensitive data which Generali have received or maintained before 1 June 2022 Generali will remain the Data Processing thereof as the same purposes. In case you do not want Generali to do so, you may exercise your right as per the Privacy Policy mentioned above.
          </p>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div class="mt-3">
      <div class="mt-2 text-center">
        <b>ข้าพเจ้าได้อ่านข้อความข้างต้นและเข้าใจโดยตลอดแล้ว</b>
      </div>
      <v-row justify="space-around">
        <v-checkbox
          v-model="acceptConsent"
          class="mx-2"
          :label="`ยอมรับข้อกำหนดและเงื่อนไขการใช้บริการ`"
          color="primary"
        ></v-checkbox>
      </v-row>
      <v-btn
        color="primary"
        depressed
        tile
        @click="handleAcceptConsent"
        :disabled="!acceptConsent"
        >ยืนยัน / CONFIRM</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      acceptConsent: false,
    };
  },
  methods: {
    handleAcceptConsent() {
      this.$emit("nextStep");
    },
  },
};
</script>

<style lang="scss" scoped></style>
